// extracted by mini-css-extract-plugin
export default {"container":"AuthWindow_container__fRBS5","auth_container":"AuthWindow_auth_container__qi8uL"};